import ModulePlanningOverviewModelBase from '../_generated/modelBases/module-planning-overview-model-base';

export default class ModulePlanningOverviewModel extends ModulePlanningOverviewModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
